module.exports = __webpack_public_path__ + "img/banner.1d52b9e2.gif";